import { useState } from 'react';
import { useParams } from 'react-router-dom';
// components
import Page from 'src/components/Page';

// paginas
import Campanhas from 'src/pages/chats/Campanhas';
import MensagensAgendadas from 'src/pages/chats/MensagensAgendadas';
import MarketingRastreamento from './MarketingRastreamento';
import MarketingMetricas from './MarketingMetricas';

// social analytics
import MktAnalytics from 'src/sections/@dashboard/marketing/analytics';
import MktAccounts from 'src/sections/@dashboard/marketing/analytics/MktAccounts';
import MktPosts from 'src/sections/@dashboard/marketing/analytics/MktPosts';

import MarketingSidebar from 'src/sections/@dashboard/marketing/MarketingSidebar/MarketingSidebar';

export default function Marketing() {
  const { label } = useParams();
  const [openSidebar, setOpenSidebar] = useState(false);

  return (
    <div className="flex w-full overflow-hidden h-[calc(100vh-64px)] lg:h-[calc(100vh-55px)]">
      <MarketingSidebar
        isOpenSidebar={openSidebar}
        onCloseSidebar={() => setOpenSidebar(false)}
      />

      <main className={`flex-1 w-full min-w-0 overflow-x-hidden relative ${label === 'metricas' ? 'overflow-hidden' : 'overflow-y-auto'}`}>
        <div className="min-h-full w-full h-full">
          {label === "campanhas" && <Campanhas />}
          {label === "agendamentos" && <MensagensAgendadas />}
          {label === "rastreamento" && <MarketingRastreamento />}
          {label === "metricas" && <MarketingMetricas />}
          {label === "analytics" && <MktAnalytics />}
          {label === "contas-sociais" && <MktAccounts />}
          {label === "publicacoes" && <MktPosts />}
        </div>
      </main>
    </div>

  );
}
